module.exports = __webpack_public_path__ + "static/img/Rectangle_346241932@2x.0489045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Rectangle_346241932@2x.png
// module id = KXvU
// module chunks = 59